export default __webpack_public_path__ + "static/media/arrows-down2-41x90.fbb6ba3c.svg";